import React from 'react';
import PropTypes from 'prop-types';

import { Source as MapboxSource } from 'react-mapbox-gl';

class Source extends React.Component {
    static propTypes = {
        id: PropTypes.string,
        systemName: PropTypes.string,
        layerData: PropTypes.object,
        sourceStyling: PropTypes.object
    };

    constructor (props) {
        super(props);
    }

    // After a source has been set, the only thing that should change is the filters applied to the source
    shouldComponentUpdate (nextProps, nextState, nextContext) {
        const { layerData } = this.props;
        if (!_.isEqual(layerData, nextProps.layerData)) { return true; }
        return false;
    }

    render () {
        const { id, systemName, layerData, sourceStyling } = this.props;

        // Don't do anything special if normal id is presented, we assume basic Mapbox format
        // Ideally structure should change to better match this format, keep closer to mapbox source
        // Instead of layerdata been created, the style is altered in the backend depending on the store before been returned
        if (id) {
            return (
                <MapboxSource
                    id={id}
                    tileJsonSource={sourceStyling}
                />
            );
        }

        // Otherwise use special custom method using layerdata created from backend
        const sourceKey = `source_${systemName}`;
        const isTiled = layerData.mvt || layerData.wms || layerData.raster;


        let tileJsonSource = undefined;
        let geoJsonSource = undefined;
        if (isTiled) {
            let tileUrl = layerData.url;
            if (layerData.filters) {
                tileUrl += '?';
                tileUrl += layerData.filters;
            }
            tileJsonSource = {
                tiles: layerData.tiles || [tileUrl],
                ...(layerData.tileSize ? { tileSize: layerData.tilesize } : null),
                ...sourceStyling
            };
        } else {
            geoJsonSource = {
                data: layerData,
                ...sourceStyling
            };
        }

        return (
            <MapboxSource
                id={sourceKey}
                tileJsonSource={tileJsonSource}
                geoJsonSource={geoJsonSource}
            />
        );
    }
}

export default Source;